/**
 * Determines the due status for a task follow-up date. The value is stored as a
 * date-only instant at midnight UTC, so the date portion is read in UTC to avoid
 * the local timezone offset shifting it to the previous/next calendar day, then
 * compared against the local "today".
 */
export function getTaskDueStatus(
    followUpDate: string | number | Date | null | undefined
): 'pastDue' | 'dueToday' | 'dueTomorrow' | 'future' | null {
    if (followUpDate == null) return null;

    const parsed = new Date(followUpDate);
    if (Number.isNaN(parsed.getTime())) return null;

    const due = new Date(parsed.getUTCFullYear(), parsed.getUTCMonth(), parsed.getUTCDate());

    const now = new Date(Date.now());
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

    const diffDays = Math.round((due.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));

    if (diffDays < 0) return 'pastDue';
    if (diffDays === 0) return 'dueToday';
    if (diffDays === 1) return 'dueTomorrow';
    return 'future';
}
